<template>
  <footer id="footer">
      <div class="container">
         <div class="row pt-5 pb-3">
                <div class="col-md-6 col-lg-3 mt-3">
                    <div class="logo-col">
                        <div class="white-logo">
                            <img src="/img/logos/coralstone-logo.svg" alt="">
                        </div>
                        <p class="text-white mt-4">On a mission to create value through investment products and financial services as the financial intermediary of choice across our target markets
                        </p>
                    </div>
                </div>

                <div class="col-lg-6 mt-3">
                    <div class="row">
                      <div class="col-6">
                        <div class="footer-links">
                          <div class="footer-header text-white">Products</div>
                          <div class="footer-link mt-4">
                              <ul>
                                  <li><a href="https://app.fundbae.ng">Fundbae</a></li>
                                  <li><a href="#">InvestGro</a></li>
                              </ul>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="footer-links">
                            <div class="footer-header text-white">Quick Link</div>
                            <div class="footer-link mt-4">
                                <ul>
                                    <li><router-link to="/terms">Terms & Conditions</router-link></li>
                                    <li><router-link to="/privacy">Privacy Policy</router-link></li>
                                    <li><router-link to="/careers">Careers</router-link></li>
                                    <li><a href="http://blog.coralstone.capital">Our Blog</a></li>
                                </ul>
                            </div>
                        </div>
                      </div>
                    </div>
                    
                </div>
                <div class="col-md-6 col-lg-3 mt-3">
                    <div class="footer-links">
                        <div class="footer-header text-white">Contact Us</div>
                        <div class="footer-link mt-4">
                            <ul>
                                <li>
                                    <div class="d-flex">
                                        <div class="mr-2">
                                            <img src="/img/icons/white/Home.svg" alt="">
                                        </div>
                                        <div class="contact-description">UAC Building, 1-5 Odunlami St, Lagos Island, Lagos</div>
                                    </div>
                                </li>
                                <li>
                                    <div class="d-flex">
                                        <div class="mr-2">
                                            <img src="/img/icons/white/mail.svg" alt="">
                                        </div>
                                        <div class="contact-description">+2348169352843</div>
                                    </div> 
                                </li>
                                <li>
                                    <div class="d-flex">
                                        <div class="mr-2">
                                            <img src="/img/icons/white/telephone.svg" alt="">
                                        </div>
                                        <div class="contact-description">info@coralstone.capital</div>
                                    </div>
                                </li>
                                <li>
                                    <div class="d-flex">
                                        <div class="">
                                            <a href="#">
                                                <img src="/img/icons/white/linkedin-square.svg" alt="">
                                            </a>
                                        </div>
                                        <div class="px-1">
                                            <a href="#">
                                                <img src="/img/icons/white/whatsapp-square.svg" alt="">
                                            </a>
                                        </div>
                                        <div class="px-1">
                                            <a href="#">
                                                <img src="/img/icons/white/facebook-square.svg" alt="">
                                            </a>
                                        </div>
                                        <div class="px-1">
                                            <a href="#">
                                                <img src="/img/icons/white/instagram-alt.svg" alt="">
                                            </a>
                                        </div>
                                        <div class="px-1">
                                            <a href="#">
                                                <img src="/img/icons/white/twitter.svg" alt="">
                                            </a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="copy-right mt-5">2020 © All rights reserved by Coralstone Capital</div>
                    </div>
                </div>
            </div>
      </div>
    </footer>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
    #footer {
        background: #2C3C90;

        .footer-links {
            .footer-header {
                font-style: normal;
                font-weight: bold;
                font-size: 18px;
                line-height: 22px;
                letter-spacing: 0.02em;
                color: #FFFFFF;
            }

            .copy-right {
                font-family: Source Sans Pro;
                font-style: normal;
                font-weight: normal;
                font-size: 12px;
                line-height: 15px;
                color: #FFFFFF;
            }
        }

        .footer-link ul {
            list-style-type: none;
            padding-left: 0px;

            li {
                padding: 5px 0px;

                a {
                    color: #fff;
                    font-family: Source Sans Pro;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 16px;
                    line-height: 20px;
                    color: #FFFFFF;
                }

                .d-flex .contact-description {
                    font-family: Source Sans Pro;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 16px;
                    line-height: 20px;
                    color: #FFFFFF;
                }
            }
        }
    }

    @media (max-width: 767px) {
        #footer {
            .logo-col {
                text-align: center;
            }
        }
    }
</style>